"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Info = exports.Carbonation = exports.Vendor = void 0;
const effect_1 = require("effect");
const NAMESPACE = 'Culligan.Device.Class.Pelican2.Chiller';
exports.Vendor = effect_1.Schema.Literal('Blupura', 'ChungHo').annotations({
    identifier: `${NAMESPACE}.Vendor`,
    description: 'The chiller model, as picked by the technician on the commissioning screen: Blupura is the legacy Box Fizz 80, ChungHo the Culligan Korea 80',
    pretty: () => vendor => ({ Blupura: 'Box Fizz 80', ChungHo: 'Culligan Korea 80' })[vendor],
});
exports.Carbonation = effect_1.Schema.Literal('SPARKLING', 'NON_SPARKLING').annotations({
    identifier: `${NAMESPACE}.Carbonation`,
    description: 'Whether the chiller carbonates, which is orthogonal to the model',
});
const infoAnnotations = {
    identifier: `${NAMESPACE}.Info`,
    description: 'The chiller the technician selected during commissioning. A chiller without a model is a Box Fizz 80: units commissioned before August 2026 saved none',
};
// The wire side carries the annotations too: encodedBoundSchema drops those of a transformation, so the protocol
// docs would otherwise inline the chiller.
const ReportedInfo = effect_1.Schema.Struct({
    vendor: effect_1.Schema.optionalWith(exports.Vendor, { exact: true }),
    type: exports.Carbonation,
}).annotations(infoAnnotations);
exports.Info = effect_1.Schema.transform(ReportedInfo, effect_1.Schema.Struct({ vendor: exports.Vendor, type: exports.Carbonation }), {
    strict: true,
    decode: ({ vendor = 'Blupura', type }) => ({ vendor, type }),
    encode: info => info,
}).annotations(infoAnnotations);
//# sourceMappingURL=chiller.js.map